var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Sales Funal")]),_c('v-btn',{on:{"click":function($event){return _vm.$emit('signed-off')}}},[_vm._v("Logout")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }